/**
 * Scroll-triggered reveal animations
 * Uses IntersectionObserver to add .is-visible class when elements enter viewport
 * One-shot: unobserves after triggering
 */
(function() {
  'use strict';

  var revealSelector = '.reveal, .reveal--left, .reveal--right, .reveal--scale, .reveal-stagger';
  var fallbackTimer = null;

  function revealAllPending() {
    document.querySelectorAll(revealSelector).forEach(function(el) {
      if (!el.classList.contains('is-visible')) {
        el.classList.add('is-visible');
      }
    });
  }

  function queueFallbackReveal() {
    window.clearTimeout(fallbackTimer);
    fallbackTimer = window.setTimeout(revealAllPending, 2800);
  }

  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAllPending();
    return;
  }

  // If observer API is unavailable, don't leave content hidden.
  if (!('IntersectionObserver' in window)) {
    revealAllPending();
    window.initScrollReveals = revealAllPending;
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.05,
    rootMargin: '0px 0px -12% 0px'
  });

  function observeElements() {
    document.querySelectorAll(revealSelector).forEach(function(el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
    queueFallbackReveal();
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  // Final safety pass once all assets are loaded.
  window.addEventListener('load', function() {
    window.setTimeout(revealAllPending, 300);
  });

  // Re-observe after AJAX content loads (e.g. collection filtering)
  window.initScrollReveals = function() {
    observeElements();
    queueFallbackReveal();
  };
})();
